import gql from 'graphql-tag'
import paramExtractor from '@/assets/modules/channels/paramExtractor'
import ttn from '@/assets/configurations/content/typeToName_en'
import { isArray } from 'util';

export default {
  data () {
    return {
      content: {}
    }
  },

  computed: {
    /**
     * Gives all content's
     * @returns {Array}
     */
    getData () {
      return this.content.set || []
    },

    /**
     * Groups content by there key's
     * @returns {Array[key,{value}]}
     */
    groupContent () {
      let rtr = {}
      for (let c of this.getData) {
        let { id, key, language, parts = {} } = c
        if (!rtr[key]) {
          rtr[key] = {
            key,
            languages: {}
          }
        }

        rtr[key].languages[language] = { ...parts, id }
      }

      return Object.entries(rtr)
    }
  },

  // Apollo...
  apollo: {
    content: {
      query: gql`query ($type: [ContentType!]) {
        content (type: $type, limit: -1) {
          info {
            total
          },
          set {
            id,
            key,
            language,
            parts {
              __typename,
              ... on ContentPage {
                body
              },
              ... on ContentEmail {
                subject,
                from,
                to,
                cc,
                bcc,
                text,
                html
              },
              ... on ContentSnippet {
                text
              }
            }
          }
        }
      }`,
      fetchPolicy: 'cache-and-network',

      variables () {
        return {
          type: this.getCurrentType
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination/providers/content.js